export default function canActOnOffer(context, event) {
  const { offer, user, location, isPast } = event;
  const isCreatedByMe = user && user.isMe;
  const isOfferedToMe = offer.user && offer.user.isMe;

  return !isPast && (isCreatedByMe || isOfferedToMe || context.me.canActOnLocation(location));
}
